import * as React from "react";
import * as classNames from "classnames";
import { backgroundStyleFromNode } from "../../../helpers/Doc/changes";

interface Message {
  role: "user" | "assistant";
  content: string;
}

function AiAssistantChat(props: any) {
  const [content, setContent] = React.useState("");
  const messages: Message[] = [
    { role: "user", content: "Hello, assistant!" },
    { role: "assistant", content: "Hello! How can I help you today?" }
  ];

  return (
    <div
      id={props.uid}
      data-is-node
      data-uid={props.uid}
      className={classNames("ai-assistant-chat", props.uid)}
      style={backgroundStyleFromNode(props)}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
        <img
          src="/assets/patient_image.svg"
          alt="Patient"
          style={{ width: 78, height: 67 }}
        />
        <span style={{ fontSize: 14, color: "#222" }}>
          Aquifer is testing an interactive experience in a few cases that allows you to interview the patient via chat. After completing your interview, you will receive AI-generated feedback.
        </span>
      </div>
      <div style={{ marginBottom: 70 }}>
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className="ai-message-body"
            style={{
              width: "80%",
              marginBottom: "5px",
              padding: "10px",
              border: "1px solid #99D4EB",
              borderRadius: 8,
              background: msg.role === "user" ? "#002362" : "#E3F7FF",
              color: msg.role === "user" ? "white" : "inherit",
              marginLeft: msg.role === "user" ? 20 : 0,
              marginRight: msg.role === "assistant" ? 20 : 0,
            }}
          >
            {msg.content}
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <input
          type="text"
          value={content}
          onChange={e => setContent(e.target.value)}
          style={{ flex: 1 }}
          placeholder="Type your message..."
        />
        <button
          type="button"
          onClick={handleClick => {}}
          aria-label="Open chat"
          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
        >
          <img
            src="/assets/blue_text_field_icon.svg"
            alt="Send"
            style={{ paddingBottom: "2%", cursor: "pointer" }}
          />
        </button>
      </div>
    </div>
  );
}

export default React.memo(AiAssistantChat);